export default "__VITE_ASSET__BzGWG4tC__"